var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewDemand0EstimationDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1012",
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1013"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1014"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 66 66",
    viewBox: "0 0 66 66",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6,58.5H8.1c-0.5,0-1-0.4-1-1c0-0.6,0.5-1,1-1h20.5v-7.8H8.1c-0.5,0-1-0.5-1-1c0-0.6,0.5-1,1-1h20.5v-7.8H8.1 c-0.5,0-1-0.4-1-1c0-0.6,0.5-1,1-1h20.5v-6.8c0-0.3,0-0.7,0.1-1H8.1c-0.5,0-1-0.4-1-1c0-0.5,0.5-1,1-1h21.1 c1.1-2.5,3.6-4.2,6.5-4.2H51v-9.6c0-0.3-0.1-0.5-0.3-0.7L39,1.7c-0.2-0.2-0.4-0.3-0.7-0.3H6.1C3.3,1.4,1,3.7,1,6.5v53.1 c0,2.8,2.3,5.1,5.1,5.1h24.7c-1.4-1.3-2.2-3.1-2.2-5.1V58.5z M39.4,4.7l8.1,7.6h-7c-0.6,0-1-0.5-1-1V4.7z M8.1,7.5h25.1 c0.6,0,1,0.5,1,1s-0.4,1-1,1H8.1c-0.5,0-1-0.5-1-1S7.5,7.5,8.1,7.5z M8.1,17.3h35.8c0.5,0,1,0.5,1,1c0,0.6-0.5,1-1,1H8.1 c-0.5,0-1-0.4-1-1C7.1,17.7,7.5,17.3,8.1,17.3z",
    fill: "current",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9,24.9H35.7c-2.8,0-5.1,2.3-5.1,5.1v29.4c0,2.8,2.3,5.1,5.1,5.1h24.1c2.8,0,5.1-2.3,5.1-5.1V30.1 C65,27.2,62.7,24.9,59.9,24.9z M41.9,57.5c0,0.5-0.4,0.9-0.9,0.9h-3.4c-0.5,0-1-0.4-1-0.9V55c0-0.5,0.4-1,1-1H41 c0.5,0,0.9,0.4,0.9,1V57.5z M41.9,48.5c0,0.5-0.4,0.9-0.9,0.9h-3.4c-0.5,0-1-0.4-1-0.9v-2.5c0-0.5,0.4-0.9,1-0.9H41 c0.5,0,0.9,0.4,0.9,0.9V48.5z M50.4,57.5c0,0.5-0.4,0.9-0.9,0.9h-3.4c-0.5,0-1-0.4-1-0.9V55c0-0.5,0.4-1,1-1h3.4 c0.5,0,0.9,0.4,0.9,1V57.5z M50.4,48.5c0,0.5-0.4,0.9-0.9,0.9h-3.4c-0.5,0-1-0.4-1-0.9v-2.5c0-0.5,0.4-0.9,1-0.9h3.4 c0.5,0,0.9,0.4,0.9,0.9V48.5z M58.9,57.5c0,0.5-0.4,0.9-0.9,0.9h-3.4c-0.5,0-0.9-0.4-0.9-0.9V45.9c0-0.5,0.4-0.9,0.9-0.9H58 c0.5,0,0.9,0.4,0.9,0.9V57.5z M58.9,40H36.6v-9h22.3V40z",
    fill: "current",
    className: "color000 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDemand0EstimationDocument);
export default __webpack_public_path__ + "static/media/view-demand0estimation-document.f7c32367bc6f313edd0706353ffa8d12.svg";
export { ForwardRef as ReactComponent };